import { Injectable } from "@angular/core";
import { UserService } from "@app/core/services";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { tap } from "rxjs/operators";
import { GetLeads, LeadStateModel } from "./index";


@State<LeadStateModel>({
    name: 'Lead',
    defaults: {
        leads: {},
        activePage: 1,
        filterResult: {}
    }
})

@Injectable()
export class LeadState {

    constructor(private userService: UserService) {}

    @Selector()
    static getLeadList(state: LeadStateModel) {
        return state.leads;
    }

    @Selector()
    static getActivePage(state: LeadStateModel) {
        return state.activePage;
    }

    @Selector()
    static getFilterResult(state: LeadStateModel) {
        return state.filterResult;
    }

    @Action(GetLeads)
    getLeads({getState, setState}: StateContext<LeadStateModel>, { pageIdex, filterResult }: GetLeads) {
        return this.userService.allbusinesss(pageIdex, filterResult).pipe(tap((res: any) => {
            const state = getState;
            setState({
                ...state,
                leads: res['data']['businesses'],
                activePage: pageIdex,
                filterResult: filterResult
            })
        }))
    }


}